module.exports = __webpack_public_path__ + "img/w3b.f4f45d56.jpg";